const scope = "analytics";
export default scope;